module.exports = __webpack_public_path__ + "img/ingalls-logo.5b41587c.jpg";